import Parse from "parse";
import { useEffect, useState } from "react";
import { Level } from "../js/parsegenerated";

/**
 *
 * @returns All levels stored in the system.
 */
export function useLevels() {
  const [levels, setLevels] = useState<Level[]>([]);
  const [reload, setReload] = useState(0);

  useEffect(() => {
    new Parse.Query(Level).find().then(setLevels);
  }, [reload]);

  return [
    levels,
    () => {
      setReload((x) => x + 1);
    },
  ] as [Level[], () => void];
}
